import arrayOfObjectsEqual from './arrayOfObjectsEqual';
export default arrayOfObjectsEqual;
